import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Fade from "react-reveal";
import TableFilter from "./Component/TableFilter";
import TableData from "./Component/TableData";

const PostIndex = (props) => {
  return (
    <Fade>
      <section className="position-relative posts">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="px-lg-5 px-md-3">
                <div className="sectionInner h-100 position-relative">
                  <TableFilter {...props} />
                  <TableData {...props} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Fade>
  );
};

export default PostIndex;
